import { useTranslationStore } from '.';
import { useMemo } from 'react';
import { useUserStore } from 'services/UserService';

export const useTranslate = () => {
  const lang = useUserStore(state => (state.user && state.user.language) || 'en_US');
  return useMemo(() => key => useTranslationStore.getState().translate(key, lang), [lang]);
};
